import { AlertTriangle } from 'lucide-react';

import { formatPercentage } from '@/utils/formatters';

type OwnershipProps = {
  fraction?: number | null;
};

export const Ownership = ({ fraction }: OwnershipProps) => {
  if (fraction === undefined || fraction === null) {
    return <p className="font-medium">N/A</p>;
  }
  if (fraction <= 1) {
    return <p className="font-medium">{formatPercentage(fraction)}</p>;
  }
  return (
    <>
      <p className="font-medium flex items-center text-destructive">
        {formatPercentage(fraction)}
        <AlertTriangle className="h-4 w-4 ml-2" aria-hidden="true" />
      </p>
      <p className="text-xs text-destructive">
        Over 100% of approved shares. Check for approved transfers out of
        unapproved issuances.
      </p>
    </>
  );
};
